import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useApi } from "../../../api";
import { Numeral } from "../../../components/Numeral";
import { INftAsset, ICargo } from "../../../interfaces";
import { Utils } from "../../../utils";
import { NftMyFavoriteCard } from "./components/NftMyFavoriteCard";

export const NftMyFavoritePage = () => {
  const projectCode = 'NFT';
  const navi = useNavigate()
  const api = useApi(projectCode);
  const [mounted, setMounted] = useState<Boolean>(false);
  const [ethRate, setEthRate] = useState<number | null>(null);
  const [assets, setAssets] = useState<INftAsset[]>([]);

  useEffect(() => {
    if (mounted) return;
    setMounted(true);

    api.getBinanceTicker('ETH', (cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        setEthRate(cargo.info['rate'])
      }
    })
    
    api.getNftFavorites((cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        setAssets(cargo.info)
      }
    })
  }, [api, assets, mounted])
  
  return (
    <>
      <div className="d-flex flex-wrap justify-content-center mx-auto pt-10" style={{ maxWidth: '1280px' }}>

        {
          assets.map(asset => {
            return (
              <NftMyFavoriteCard key={asset.nftId} asset={asset} projectCode={projectCode} ethRate={ethRate} />
            )
          })
        }
      </div>
    </>
  )
}